export type CheckoutStepType = {
  label: string;
  id: "installation-date" | "add-ons" | "pay-deposit";
  breadcrumb: string;
};

export const checkoutSteps: CheckoutStepType[] = [
  {
    label: "Select Installation Date",
    id: "installation-date",
    breadcrumb: "Installation Date"
  },
  { label: "Select Add-ons / Extra Services", id: "add-ons", breadcrumb: "Select Add-ons" },
  { label: "Pay Deposit to secure your booking", id: "pay-deposit", breadcrumb: "Pay Deposit" }
];

export const tabIds = {
  "installation-date": 0,
  "add-ons": 1,
  "pay-deposit": 2
};
export const timer = new Date(Date.now() + 1000 * 600);
export const benefitData = [
  { image: "images/checkout/hand_with_start.png", label: "Swyft Energy <br/> Happiness Guarantee" },
  { image: "images/checkout/workmanship.png", label: "Swyft Energy <br/> Workmanship Guarantee" },
  {
    image: "images/checkout/people.png",
    label: "Dedicated Account Manager from <br/> start to finish 12,500+ Installations"
  },
  { image: "images/checkout/5start.png", label: "4.8/5 rating based on <br/> 500+ google reviews" },
  { image: "images/checkout/investors.png", label: "Backed by <br/> institutional investors" }
];
